var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { xs: "12" } },
            [_c("date-filter", { attrs: { namespace: _vm.namespace } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [_c("rest-point-filter", { attrs: { namespace: _vm.namespace } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("delivery-type-filter", {
                attrs: { namespace: _vm.namespace }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex mb-2 mt-3" },
        [
          _c("h4", { staticClass: "mt-0 mr-3" }, [
            _vm._v("Статистика выполнения заказов по промежуткам")
          ]),
          _vm._v(" "),
          _vm.timeOrderLoading ? _c("b-spinner", {}) : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-table",
        _vm._b(
          {
            scopedSlots: _vm._u([
              {
                key: "timeTo",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.getIntervalTitle(data.item)) +
                        "\n    "
                    )
                  ]
                }
              },
              {
                key: "percentCount",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          data.value ? (data.value * 100).toFixed(2) + " %" : ""
                        ) +
                        "\n    "
                    )
                  ]
                }
              },
              {
                key: "percentSum",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          data.value ? (data.value * 100).toFixed(2) + " %" : ""
                        ) +
                        "\n    "
                    )
                  ]
                }
              }
            ])
          },
          "b-table",
          _vm.tableProps,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "table-busy" },
              slot: "table-busy"
            },
            [_c("strong", [_vm._v("Загрузка статистики...")])]
          ),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _c("template", { slot: "FOOT_count" }, [
            _vm._v("\n      " + _vm._s(_vm.countTotal) + "\n    ")
          ]),
          _vm._v(" "),
          _c("template", { slot: "FOOT_sum" }, [
            _vm._v("\n      " + _vm._s(_vm.sumTotal) + "\n    ")
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3afba44a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afba44a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatsOrderCompletion.vue
// module id = null
// module chunks = 